// ProgressBar.js
// import { TextField, IMaskInput } from '@mui/material';
import { IMaskInput } from 'react-imask';
import React from 'react';
import { TextField } from '@mui/material';

const TextFieldCustom = ({ label, type, errorText, onChange, value }) => {
    return (
        <TextField
        value={value}
        label={label} variant="outlined"
        hiddenLabel={true}
        InputLabelProps={label}
        type={type}
        error={errorText}
        helperText={errorText}
        onChange={onChange}
        margin='dense'
        minRows={1}
        maxRows={1}
        fullWidth
        inputProps={{readOnly: false}}
        />
    );
};

export default TextFieldCustom;
